export class TransactionError extends Error {
  static create(errorMessage) {
    return new TransactionError(errorMessage)
  }
}
